export const selectInteractions = (state) => state.interactions.interactionsPag;
export const selectAllInteraction = (state)=> state.interactions.interactions;

export const selectInteractionsLoading = (state) => state.interactions.loading;